<template>
  <div class="bounty-list">
    <div ref="container">
      <div v-for="item in list" :key="item.id">
        <BountyItem :target="item" />
      </div>
    </div>
    <EmptyBanner v-if="list.length===0" :label="$t('home.emptyList')" />
    <LoadMore v-if="total>list.length" :loading="loading" @click="loadMore" />
  </div>
</template>

<script>
import BountyItem from '@/views/Home/BountyItem.vue';
import Macy from 'macy';
import URLS from '@/config/url';
import LoadMore from '@/components/LoadMore.vue';
import EmptyBanner from '@/components/EmptyBanner.vue';

export default {
  name: 'BountyList',
  components: { EmptyBanner, LoadMore, BountyItem },
  props: {
    tab: {
      type: String,
      require: true,
      default: 'all',
    },
  },
  data() {
    return {
      list: [],
      macyInstance: null,
      total: 0,
      currentPage: 1,
      loading: false,
    };
  },
  methods: {
    refresh() {
      this.currentPage = 1;
      this.list = [];
      this.total = 0;
      this.clearMacy();
      this.fetchBountyList();
    },
    getStatus(tab) {
      switch (tab) {
        case 'completed': {
          return [3];
        }
        case 'uncompleted': {
          return [1, 2];
        }
        default: {
          return [1, 2, 3];
        }
      }
    },
    initMacy() {
      this.macyInstance = Macy({
        container: this.$refs.container,
        columns: 2,
        margin: 40,
        breakAt: {
          800: 1,
        },
      });
    },
    clearMacy() {
      if (this.macyInstance) {
        this.macyInstance.remove();
        this.macyInstance = null;
      }
    },
    updateMacy() {
      this.macyInstance.recalculate();
    },
    loadMore() {
      this.currentPage += 1;
      this.fetchBountyList();
    },
    fetchBountyList() {
      this.loading = true;
      this.$request({
        url: URLS.bountyList,
        method: 'POST',
        data: {
          page_size: 10,
          page_number: this.currentPage,
          sortByHot: this.tab === 'hot',
          status: this.getStatus(this.tab),
        },
      }).then((res) => {
        this.total = res.result.total;
        this.list = this.list.concat(res.result.list);
        if (this.list.length > 0) {
          this.$nextTick(() => {
            if (this.macyInstance) {
              this.updateMacy();
            } else {
              this.initMacy();
            }
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.fetchBountyList();
  },
  beforeDestroy() {
    this.clearMacy();
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .bounty-list {
    padding-top: $padding-common;
  }
</style>
